<template>
  <div class=Intro>
    <transition name=fade>
      <div class="intro" v-show=show >
        <h1>명데와 <img src="/static/img/myoungdaySD.png" alt=""> 함께하는</h1>
        <img class=logo src="/static/img/logo.png" alt="logo" @load=loaded>
        <div class="text-right">
          <h3>in Don't Starve Together <img src="/static/img/dst_logo.png" style="width: 50px; height: 50px;"></h3>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  data: () => ({
    show: false
  }),
  mounted () {
  },
  methods: {
    loaded () {
      this.show = true
      setTimeout(() => {
        this.show = false
        setTimeout(() => {
          this.$emit('end')
        }, 1000)
      }, 3000)
    }
  }
}
</script>

<style scoped>
.Intro {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  background-color: #dab3f2;
}
h1 img {
  width: 50px;
}
.logo {
  width: 50vw;
}
.fade-enter-active {
  transition: opacity 3s ease-out;
}
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
  transform: translate(0, 100px);
}
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue